import * as styles from "../../../styles/AdvicePage";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Navigate, useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useState } from "react";
import imageCompression from "browser-image-compression";
import userSlice from "../../../reducer/user";
import { useAppDispatch } from "../../../store";
import { CreateCounsel } from "../../../reduxaction/post";

import dayjs from "dayjs";
import "dayjs/locale/ko";
import Modal from "../../../components/Modal";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducer";
dayjs.locale("ko");

const Advicewrite = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { CreateCouncelLoading } = useSelector(
    (state: RootState) => state.post
  );

  const { me } = useSelector((state: RootState) => state.user);
  const [imageSources, setImageSources] = useState<any>([]);
  const [apiImages, setapiImages] = useState<any>([]);
  const [counsel, setCounsel] = useState({
    title: "",
    description: "",
    privateYn: "N",
  });

  const [postmodal, setPostmodal] = useState<boolean>(false);

  useEffect(() => {
    dispatch(userSlice.actions.Routerpath("/Advicewrite"));
  }, []);

  const onChangefunc = useCallback(
    (
      e:
        | React.ChangeEvent<HTMLInputElement>
        | React.ChangeEvent<HTMLTextAreaElement>
    ) => {
      setCounsel({ ...counsel, [e.target.name]: e.target.value });
    },
    [counsel]
  );
  const postfunc = useCallback(
    async (type: string) => {
      if (CreateCouncelLoading) {
        return confirmAlert({
          title: "작성중입니다.",
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
      }

      if (type === "YES") {
        if (!counsel.title) {
          return confirmAlert({
            title: "제목을 입력해주세요.",
            buttons: [
              {
                label: "Yes",
              },
            ],
          });
        }
        if (!counsel.description) {
          return confirmAlert({
            title: "내용을 입력해주세요.",
            buttons: [
              {
                label: "Yes",
              },
            ],
          });
        }
        let data = {
          title: counsel.title,
          description: counsel.description,
          privateYn: counsel.privateYn,
          uploadimages: apiImages,
        };

        await dispatch(CreateCounsel(data));

        navigate(-1);
      } else if (type === "NO") {
        setPostmodal(false);
      }
    },
    [counsel, apiImages, CreateCouncelLoading]
  );

  const onChangeImages = useCallback(
    async (e: any) => {
      const file = e.target.files[0];

      const image = new Image();
      image.src = URL.createObjectURL(file);

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        canvas.width = 800;
        canvas.height = 600;

        context?.drawImage(image, 0, 0, 800, 600);

        const resizedImage = canvas.toDataURL();
        setImageSources([...imageSources, resizedImage]);
      };

      setapiImages([...apiImages, file]);
    },
    [imageSources, apiImages]
  );

  const removeimagefunc = useCallback(
    (Image: string, idx: number) => {
      let copyimg = [...imageSources];
      let InxImage = copyimg.indexOf(Image);
      copyimg.splice(InxImage, 1);
      setImageSources([...copyimg]);

      let copyapiImages = [...apiImages];
      copyapiImages.splice(InxImage, 1);
      setapiImages([...copyapiImages]);
    },
    [imageSources, apiImages]
  );
  const today = new Date();

  const day = dayjs(today).format("YYYY년 MM월 DD일 dddd HH시 mm분");

  return (
    <styles.Container>
      <styles.PageTop2>
        <p
          className="left-arrow"
          onClick={() => {
            navigate(-1);
          }}
        >
          <img src="./img/ArrowLeft.svg" />
        </p>
        <button className="write-submit" onClick={() => setPostmodal(true)}>
          작성
        </button>
      </styles.PageTop2>

      <styles.WriteForm>
        <div className="writeform-top">
          <p className="writeform-name">{me?.userId}</p>
          <p className="writeform-date">{day}</p>
        </div>
        <div className="writeform-box">
          <p className="writeform-title">제목</p>
          <input type="text" id="title" name="title" onChange={onChangefunc} />
          <p className="writeform-title">내용</p>
          <textarea
            id="description"
            name="description"
            onChange={onChangefunc}
          />
          {/* <label>
            <input
              type="checkbox"
              name="privateYn"
              id="privateYn"
              value={counsel.privateYn === "N" ? "Y" : "N"}
              onChange={onChangefunc}
            />
            비밀글
          </label> */}
        </div>
      </styles.WriteForm>

      <styles.ImageUpLoadBox>
        <p className="content-tit">사진</p>
        <styles.ImageUpload>
          <label htmlFor="file">
            <div className="camera-btn">
              <p className="camera-img">
                <img src="./img/camera.svg" />
              </p>
            </div>
          </label>
          <input
            type="file"
            id="file"
            accept="image/jpg, image/png, image/jpeg"
            multiple
            onChange={onChangeImages}
          />
          {imageSources.map((Image: any, idx: any) => {
            return (
              <div>
                <styles.PreviewIamge>
                  <img src={Image} alt={idx} />
                  <div onClick={() => removeimagefunc(Image, idx)}>x</div>
                </styles.PreviewIamge>
              </div>
            );
          })}
        </styles.ImageUpload>
      </styles.ImageUpLoadBox>
      {postmodal && (
        <Modal
          title={"작성하시겠습니까?"}
          first={"예"}
          second={"아니오"}
          firstclick={() => postfunc("YES")}
          secondclick={() => postfunc("NO")}
        />
      )}
    </styles.Container>
  );
};

export default Advicewrite;
